import { render, staticRenderFns } from "./DifficultyPage.vue?vue&type=template&id=71368502&"
import script from "./DifficultyPage.vue?vue&type=script&lang=js&"
export * from "./DifficultyPage.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports